(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"));
	else if(typeof define === 'function' && define.amd)
		define(["React"], factory);
	else if(typeof exports === 'object')
		exports["ExampleComponent"] = factory(require("React"));
	else
		root["ExampleComponent"] = factory(root["React"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__4883__) => {
return 